import React from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';

const ReviewSnippets = ({data, reviews, isLoading}) => {

  if (isLoading || reviews.length === 0) {
    return null;
  }

  const providerName = ('provider_name' in data) ? data.provider_name : data.name;
  const name = ('title' in data) ? data.title : data.name;

  const reviewJSONLD = review => {
    return {
      '@type': 'Review',
      'author': review.author_username,
      'datePublished': review.created_at,
      'reviewBody': review.content,
      'reviewRating': {
        '@type': 'Rating',
        'bestRating': '5',
        'ratingValue': review.rating,
        'worstRating': '1'
      }
    };
  };

  const dataJSONLD = {
    '@context': 'http://schema.org',
    '@type': 'LocalBusiness',
    'name': name,
    'image': data.image_path,
    'description': data.short_description,
    'brand': providerName,
    'aggregateRating': {
      '@type': 'AggregateRating',
      'ratingValue': data.rating,
      'reviewCount': data.review_count,
      'description': data.short_description,
      'name': name,
    },
    'review': [reviews.map(r => reviewJSONLD(r))]
  };

  return (
    <Helmet>
      <script className='structured-data-list' type='application/ld+json'>
        {JSON.stringify(dataJSONLD)}
      </script>
    </Helmet>
  );
};

ReviewSnippets.propTypes = {
  data: PropTypes.object.isRequired,
  reviews: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default ReviewSnippets;
